import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { environmentProvider } from '@shared/environment-provider';

@Component({
  selector: 'onboarding-redirect',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class OnboardingRedirectComponent implements OnInit {
  private readonly router = inject(Router);

  ngOnInit() {
    let redirect = this.router.url.replace(/^\/onboarding/i, 'auth');

    if (redirect.startsWith('auth/menu')) {
      redirect = this.router.url.replace(/^auth/, 'app');
    }

    window.location.href = `${environmentProvider.getEnvironment().onboardingSiteUrl}/${redirect}`;
  }
}
